// extracted by mini-css-extract-plugin
export default {"fruitbasketexample":"fruitbasketexample_a98e426cd6be72caa579"};